// extracted by mini-css-extract-plugin
module.exports = {"root":"ChatMenuItem_root__D8jpm","icon":"ChatMenuItem_icon__L97hv"};